<template>
  <div :class="$style.container">
    <div
      :class="[
        $style.container__consultProfessional,
        $style.consultProfessional,
      ]"
    >
      <img
        :class="$style.consultProfessional__img"
        src="./manzokudo.svg"
        alt=""
        loading="lazy"
      />
      <p :class="$style.consultProfessional__subheading">
        <slot />
      </p>
      <p :class="$style.consultProfessional__heading">
        満足度4.9<span :class="$style.consultProfessional__kome">※</span
        ><br :class="$style.mobile" />のプロに相談
      </p>
      <p :class="$style.consultProfessional__notice">
        ※2023年度末実施の当社データベースにおける調査による、クチコミの平均点
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  padding-top: 103px;
  padding-bottom: 48px;
}

.consultProfessional {
  @include create-stacking-context;
  position: relative;
  padding: 84px 16px 16px;
  @include mobile-only {
    padding: 48px 16px 16px;
  }
  width: 100%;
  color: $color-text-and-object-high-emphasis-inverse;
  background-color: $color-surface-accent-primary;
  &__img {
    width: 480px;
    max-width: 90%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -60%);
  }
  &__subheading {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
    word-break: keep-all;
    @include mobile-only {
      font-size: 18px;
      font-weight: 400;
    }
  }
  &__heading {
    margin-top: 16px;
    text-align: center;
    font-size: 48px;
    font-weight: 600;
    line-height: 48px;
    word-break: keep-all;
    @include mobile-only {
      font-size: 32px;
      font-weight: 600;
    }
  }
  &__kome {
    font-size: 12px;
    font-weight: 600;
  }
  &__notice {
    margin-top: 16px;
    text-align: center;
    font-size: 10px;
    line-height: 10px;
  }

  &::before {
    z-index: -1;
    background-color: $color-surface-accent-primary;
    content: '';
    display: block;
    width: 180px;
    height: 60px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 80%);
    clip-path: path('M 5 -2 L 90 60, 175 -2 z');
  }
}

.mobile {
  @include tablet-upper {
    display: none;
  }
}
</style>
